import 'react-toastify/dist/ReactToastify.css';

import * as Sentry from 'raven-js';
import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';

import withAuthorization, { AuthorizationProps } from '../../hocs/Authorization';
import { CONFIG } from '../../meta/types/config';
import Routes from '../../Routes';
import GlobalStyle from '../../styles/global';
import DEFAULT_THEME from '../../styles/Theme';
import { VERSION_INFO } from '../../version';

class App extends React.Component<AuthorizationProps> {
  constructor(props: AuthorizationProps) {
    super(props);
    if (CONFIG.sentry.enable) {
      this.installSentry();
    }
  }

  componentDidMount() {
    Sentry.captureBreadcrumb({
      level: 'info',
      category: 'ui',
      message: `App mounted on ${window.location.href}`,
      data: VERSION_INFO,
    });
  }

  installSentry = () => {
    Sentry.config(CONFIG.sentry.dsn, {
      environment: CONFIG.sentry.env,
      release: VERSION_INFO.tag,
    }).install();
  };

  render() {
    return (
      <Route
        render={({ location }) => {
          return (
            <ThemeProvider theme={DEFAULT_THEME}>
              <>
                <GlobalStyle />
                <Routes location={location} />
                <ToastContainer autoClose={3000} pauseOnHover />
              </>
            </ThemeProvider>
          );
        }}
      />
    );
  }
}

const AuthorizedApp = withAuthorization(App);

export default withRouter(AuthorizedApp);
